export default "__VITE_ASSET__DXmD5l3V__"